import { getFontSize } from '../../../../constants/fontSizes';

export const listingSectionStyles = {
  card: {
    padding: {xs: "20px", lg: '40px'},
    backgroundColor: 'secondary.main',
    borderRadius: '14px',
    boxShadow: 'none',
  },
  title: {
    fontFamily: 'Aurora',
    fontWeight: 700,
    fontSize: getFontSize(50),
    lineHeight: {xs: '36px', lg: '56px'},
    letterSpacing: '-1%',
    color: '#1F1F1F',
    marginBottom: {xs: '20px', lg: '32px'},
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    paddingTop: '24px',
    paddingBottom: '24px',
  },
  divider: {
    borderTop: '1px solid #E3E3E3',
    marginTop: "25px"
  },
  chipsContainer: {
    display: 'flex',
    gap: {xs: "5px", lg: '16px'},   
    flexWrap: 'wrap',
  
  },
  chipDefault: {
    backgroundColor: 'secondary.main',
    color: '#1F1F1F',
    minHeight: {xs: "50px", lg: 'auto'},
    border: '2px solid #EAEAEA',
    borderRadius: '60px',
    fontFamily: 'Lato',
    fontWeight: 600,
    fontSize: getFontSize(18),
    lineHeight: '100%',
    letterSpacing: '0%',
    padding: {xs: "15px", lg: '24px'},
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
    '& .MuiChip-icon': {
      color: '#1F1F1F',
      marginLeft: '0px',
    },
  },
  chipSelected: {
    minHeight: {xs: "50px", lg: 'auto'},
    backgroundColor: '#EAEAEA',
    color: 'primary.main',
    border: '2px solid #EAEAEA',
    borderRadius: '60px',
    padding: {xs: "15px", lg: '24px'},
    fontFamily: 'Lato',
    fontWeight: 600,
    fontSize: getFontSize(18),
    lineHeight: '100%',
    letterSpacing: '0%',
    cursor: 'pointer',
    '& .MuiChip-icon': {
      color: 'primary.main',
      marginLeft: '0px',
    },
  },
  chipIcon: {
    width: '20px',
    height: '20px',
    objectFit: 'contain',
  },
  submitButton: {
    backgroundColor: 'primary.main',
    color: 'secondary.main',
    lineHeight: '30px',
    width: {xs: "100%", lg: 'auto'},
    textTransform: 'none',
    padding: '15px 40px',
    fontSize: getFontSize(18),
    fontWeight: 500,
    borderRadius: '50px',
    marginTop: '32px',
    '&:hover': {
      backgroundColor: 'primary.dark',
    },
  },
};

